import { trpc } from '@/shared/api/trpc';

type Options = {
  enabled?: boolean;
};

export const useTourOperatorByIdData = (id: string | null, options?: Options) =>
  trpc.operations.tourOperatorById.useQuery(
    { id: id ?? '' },
    {
      enabled: (options?.enabled ?? true) && !!id,
    }
  );
